import type { FC, ReactNode } from 'react'
import type { GetServerSideProps } from 'next'

import Link from 'next/link'
import { useRouter } from 'next/router'
import { Seo } from '@/components/generals/seo'
import AuthShell from '@/components/account/auth-shell'
import { RegisterForm } from '@/components/account/auth-forms'
import { safeNext } from '@/lib/safe-redirect'

interface RegisterPageProps {
    next: string
}

const RegisterPage: FC<RegisterPageProps> = ({ next }): ReactNode => {
    const router = useRouter()

    return (
        <AuthShell
            eyebrow='Mijn ArtDoors'
            title='Account aanmaken'
            description='Bewaar uw ontwerpen, vraag offertes aan en volg straks elke stap van de productie van uw deur.'
        >
            <Seo title='Account aanmaken' noIndex />

            <RegisterForm onSuccess={() => router.push(next)} />

            <p className='mt-8 border-t border-border pt-6 text-sm text-muted-foreground'>
                Heeft u al een account?{' '}
                <Link href={`/account/inloggen${next !== '/account' ? `?volgende=${encodeURIComponent(next)}` : ''}`} className='font-medium text-foreground underline underline-offset-4'>
                    Log in
                </Link>
            </p>
        </AuthShell>
    )
}

export const getServerSideProps: GetServerSideProps<RegisterPageProps> = async context => {
    const { getSessionUser } = await import('@/lib/server/auth')
    const next = safeNext(context.query.volgende)
    const user = await getSessionUser(context.req)

    if (user) return { redirect: { destination: next, permanent: false } }

    return { props: { next } }
}

export default RegisterPage
